import { render, staticRenderFns } from "./ApprovalFlow.vue?vue&type=template&id=77f6fee2&"
import script from "./ApprovalFlow.vue?vue&type=script&lang=js&"
export * from "./ApprovalFlow.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalFlow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports